import {
  StatusError,
  StatusOK,
  StatusWarning,
} from '@backstage/core-components';

export const scoreRules = {
  red: {
    text: 'Immediate Action Required',
    rule: (severity: string) => severity === 'CRITICAL',
    info: `CRITICAL vulnerabilities > 0.`,
    icon: StatusError,
  },
  orange: {
    text: 'Action Required',
    rule: (severity: string) => severity === 'HIGH',
    info: `HIGH Vulnerabilities > 0 & no CRITICAL.`,
    icon: StatusWarning,
  },
  green: {
    text: 'No Action Required',
    info: `No vulnerabilities.`,
    icon: StatusOK,
  },
};
